<template>
  <b-container fluid class="theme-yellow">
    <div class="page-header">
      <Navbar text="Companion" />
    </div>

    <section>
      <h2>What is Harpra Companion?</h2>

      <p>
        Harpra Companion is your tool to begin sending your 3D Models directly to your customers.
        Upload your models, create an Immersive Brochure, then send the access code directly to the
        customer you would like to share the content with. It is that simple!
      </p>

      <h2>Get Started</h2>

      <b-button variant="primary" :to="{ name: 'CompanionModels', query: { add: true } }" class="mr-3">
        Upload Models
      </b-button>

      <b-button variant="primary" :to="{ name: 'Brochures', query: { add: true } }" class="mr-3">
        Create Brochure
      </b-button>
    </section>

    <section>
      <h2>Companion apps</h2>

      <p>
      </p>

      <b-card-group deck class="mobile-apps-deck">
        <b-card>
          <qrcode-vue class="app-qr-code" :value="appleAppStoreLink" size="100%" level="L" render-as="svg" />
          <b-card-body>
            <a :href="appleAppStoreLink">
              <img class="app-badge" :src="require(`@/assets/images/apple-appstore-badge.png`)">
            </a>
          </b-card-body>

          <template #footer>
            <small class="text-muted">Harpra Companion for iOS</small>
          </template>
        </b-card>
        <b-card>
          <qrcode-vue class="app-qr-code" :value="googlePlayStoreLink" size="100%" level="L" render-as="svg" />
          <b-card-body>
            <a :href="googlePlayStoreLink">
              <img class="app-badge" :src="require(`@/assets/images/google-play-badge.png`)">
            </a>
          </b-card-body>

          <template #footer>
            <small>Harpra Companion for Android</small>
          </template>
        </b-card>
      </b-card-group>
    </section>

    <section>
      <h2>Resources</h2>

      <div class="resources">
        <b-embed
          type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/_WpnLr2T3a0"
          allowfullscreen
        ></b-embed>
      </div>
    </section>
  </b-container>
</template>

<script>
import Navbar from "@/components/Navigation/Navbar";
import * as harpraApi from "@/services/api.service";
import * as routerUtils from "@/utils/router-utils";
import QrcodeVue from 'qrcode.vue'

export default {
  name: "Companion",
  data() {
    return {
      subscriptionActive: false,
      googlePlayStoreLink: "https://play.google.com/store/apps/details?id=com.harvinar.harpracompanion",
      appleAppStoreLink: "https://apps.apple.com/pl/app/harpra-companion/id1539475874"
    };
  },
  components: {
    Navbar,
    QrcodeVue
  },
  computed: {},
  methods: {},
  created() {
    this.$AuthService.getAccessToken(
      async () => {
        try {
          let subscriptionInfo = await harpraApi.getSubscriptionInfo(
            this.$AuthService.token.accessToken
          );

          this.subscriptionActive = subscriptionInfo.isActive;
        } catch (error) {
          console.log("[WARN ] Couldn't get subscription info.");

          this.subscriptionActive = false;
        }

        if (!this.subscriptionActive) {
          routerUtils.routeToAccount(this);
        }
      },
      () => {
        console.log("[ERROR] Couldn't get access token.");
      }
    );
  },
  mounted() {},
};
</script>
